var map = {
	"./boar.jpg": "01be",
	"./bound.jpg": "7dc6",
	"./bracken.jpg": "d9d4",
	"./composite.jpg": "83a4",
	"./dapitan.jpg": "081f",
	"./dapitana.jpg": "684c",
	"./death.jpg": "fd25",
	"./guerrico.jpg": "65f8",
	"./jesus.jpg": "0d4b",
	"./mercado.jpg": "cfe1",
	"./revenge.jpg": "1750"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1141";